// Utilitários para formatação de moeda

/**
 * Formata um número para o formato de moeda brasileira
 */
export const formatCurrency = (
  value: number,
  currency = 'BRL',
  locale = 'pt-BR'
): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(value);
};

/**
 * Remove a formatação de moeda e retorna apenas o número
 */
export const parseCurrency = (value: string, ignoredLocale = 'pt-BR'): number => {
  if (!value) return 0;
  let v = String(value);
  v = v.replace(/[^0-9.,-]/g, '');
  const lastComma = v.lastIndexOf(',');
  const lastDot = v.lastIndexOf('.');
  const decimalIndex = Math.max(lastComma, lastDot);
  if (decimalIndex === -1) {
    const digitsOnly = v.replace(/[^0-9-]/g, '');
    return parseFloat(digitsOnly) || 0;
  }
  const integerPart = v.slice(0, decimalIndex).replace(/[^0-9-]/g, '');
  const fractionalPart = v.slice(decimalIndex + 1).replace(/[^0-9]/g, '');
  const normalized = `${integerPart}.${fractionalPart}`;
  return parseFloat(normalized) || 0;
};

/**
 * Formata um valor para exibição no input (sem símbolo de moeda)
 */
export const formatCurrencyInput = (value: number, locale = 'pt-BR'): string => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/**
 * Máscara para input de moeda em tempo real
 */
export const applyCurrencyMask = (value: string, locale = 'pt-BR'): string => {
  const digits = value.replace(/\D/g, '');
  if (!digits) return '';
  const number = parseInt(digits, 10) / 100;
  return formatCurrencyInput(number, locale);
};

export const getCurrencyLocale = (currency: string): string => {
  switch (currency) {
    case 'USD':
      return 'en-US';
    case 'EUR':
      return 'de-DE';
    case 'GBP':
      return 'en-GB';
    case 'BRL':
    default:
      return 'pt-BR';
  }
};
